import { render, staticRenderFns } from "./parcelDetails_kdy.vue?vue&type=template&id=27617ef0&scoped=true&"
import script from "./parcelDetails_kdy.vue?vue&type=script&lang=js&"
export * from "./parcelDetails_kdy.vue?vue&type=script&lang=js&"
import style0 from "./parcelDetails_kdy.vue?vue&type=style&index=0&id=27617ef0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27617ef0",
  null
  
)

export default component.exports